import { TabPills } from 'marketing-site/src/library/components/TabPills'
import { HeroVertical } from 'marketing-site/src/mvp/library/components/HeroVertical'
import React, { useState } from 'react'
import { ISolutionPage } from '.'
import { CapabilitiesTab } from './tabs/capabilities'
import { OverviewTab } from './tabs/overview'
import { ResourcesTab } from './tabs/resources'

// TODO: This is a prototype page. It needs:
// - Use the correct components
// - Percy stories
// - Tests
export function SolutionPage(page: ISolutionPage): React.ReactElement {
  const [activeTab, setActiveTab] = useState<'overview' | 'capabilities' | 'resources'>('overview')

  return (
    <div>
      {page.hero && <HeroVertical {...page.hero} />}

      {page.solution && (
        <>
          <TabPills
            tabPills={[
              {
                text: 'Overview',
                isActive: activeTab === 'overview',
                onClick: () => setActiveTab('overview'),
              },
              {
                text: 'Capabilities',
                isActive: activeTab === 'capabilities',
                onClick: () => setActiveTab('capabilities'),
              },
              {
                text: 'Resources',
                isActive: activeTab === 'resources',
                onClick: () => setActiveTab('resources'),
              },
            ]}
          />
          {activeTab === 'overview' && <OverviewTab {...page} />}
          {activeTab === 'capabilities' && <CapabilitiesTab {...page} />}
          {activeTab === 'resources' && <ResourcesTab {...page} />}
        </>
      )}
    </div>
  )
}
